<template>
    
  <card class="card" title="Editar columna">
  <div>

      <formColumna :id="getId"/>

  </div>
  </card>


</template>


<script>

import formColumna from './_form';


export default{

  name:"editarColumna",
  components:{
      formColumna
  },

  computed:{

    getId(){

      

        return parseInt(this.$route.params.id);

      
    }

  },
  
  data(){


      return{

      }

  }


}

</script>